import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import 'luxon';
import 'react';
import 'lodash';
import '../../../icons/ActivityIcon.js';
import '../../../icons/ArrowDownIcon.js';
import '../../../icons/ArrowDownRightCircleIcon.js';
import '../../../icons/ArrowLeftAlignIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightAlignIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/ArrowSwitchIcon.js';
import '../../../icons/ArrowUpIcon.js';
import '../../../icons/ArrowUpRightCircleIcon.js';
import '../../../icons/ArrowsAngleExpandIcon.js';
import '../../../icons/BankIcon.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/CrossIcon.js';
import '../../../icons/DaiIcon.js';
import '../../../icons/DangerIcon.js';
import '../../../icons/DownSortIcon.js';
import '../../../icons/ExclamationTriangleIcon.js';
import '../../../icons/ExpandKpiIcon.js';
import '../../../icons/EyeIcon.js';
import '../../../icons/EyeSlashIcon.js';
import '../../../icons/Grid1x2Icon.js';
import '../../../icons/InfoCircleIcon.js';
import '../../../icons/ListIcon.js';
import '../../../icons/LockIcon.js';
import '../../../icons/MediumIcon.js';
import '../../../icons/MoonIcon.js';
import '../../../icons/PiggyBankIcon.js';
import '../../../icons/QuestionMarkCircleIcon.js';
import '../../../icons/ShieldIcon.js';
import '../../../icons/SunIcon.js';
import '../../../icons/UpSortIcon.js';
import '../../../icons/XIcon.js';
import '../../../icons/InfinityIcon.js';
import '../../../icons/ArrowUpRightBoxIcon.js';
import '../../../molecules/CurrencyValue/components/Value.js';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import '../../../../theme/ThemedComponentWrapper.js';
import '../../../molecules/KpiCard/KpiCard.js';
import '../../../molecules/PercentageValue.js';
import '../../../molecules/Tabs/Tabs.js';
import '../../../molecules/TrendValue.js';
import '../../../pictograms/EthPictogram.js';
import '../../../pictograms/EtherScanPictogram.js';
import '../../../pictograms/DebankPictogram.js';
import '../../../pictograms/ZapperPictogram.js';
import '../../../pictograms/DaiPictogram.js';
import '../../../molecules/Modal/Modal.js';
import '@floating-ui/react';
import '../../../charts/ChartKpis/ChartKpi.js';
import '../../../charts/ChartJS.js';
import '../../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../../XRay.js';
import 'ethereum-blockies-base64';
import Flex from '../Flex/Flex.js';
import '../../Table/components/Pagination/Pagination.js';
import '../../Table/Table.js';
import '../../ToggleSwitch.js';
import '../../Tooltip/components/TooltipContext.js';

const StackWrapper = styled(Flex) `
  max-width: fit-content;
`;
function Stack({ children, ...rest }) {
    return (jsx(StackWrapper, { flexDirection: "column", gap: "s", ...rest, children: children }));
}

export { Stack as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhY2suanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2F0b21zL2xheW91dC9TdGFjay9TdGFjay50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdzdHlsZWQtY29tcG9uZW50cyc7XG5pbXBvcnQgeyBGbGV4IH0gZnJvbSAnQGF0b21zJztcbmltcG9ydCB7IEZsZXhQcm9wcyB9IGZyb20gJy4uL0ZsZXgvRmxleCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgU3RhY2tQcm9wcyBleHRlbmRzIEZsZXhQcm9wcyB7fVxuXG5jb25zdCBTdGFja1dyYXBwZXIgPSBzdHlsZWQoRmxleCk8U3RhY2tQcm9wcz5gXG4gIG1heC13aWR0aDogZml0LWNvbnRlbnQ7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBTdGFjayh7IGNoaWxkcmVuLCAuLi5yZXN0IH06IFN0YWNrUHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8U3RhY2tXcmFwcGVyIGZsZXhEaXJlY3Rpb249XCJjb2x1bW5cIiBnYXA9XCJzXCIgey4uLnJlc3R9PlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvU3RhY2tXcmFwcGVyPlxuICApO1xufVxuIl0sIm5hbWVzIjpbIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQU1BLE1BQU0sWUFBWSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBWTs7Q0FFNUM7QUFFYSxTQUFVLEtBQUssQ0FBQyxFQUFFLFFBQVEsRUFBRSxHQUFHLElBQUksRUFBYyxFQUFBO0FBQzdELElBQUEsUUFDRUEsR0FBQyxDQUFBLFlBQVksRUFBQyxFQUFBLGFBQWEsRUFBQyxRQUFRLEVBQUMsR0FBRyxFQUFDLEdBQUcsRUFBSyxHQUFBLElBQUksWUFDbEQsUUFBUSxFQUFBLENBQ0k7QUFFbkI7Ozs7In0=
